// app/javascript/controllers/export_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["table"]

    export() {
        const dataType = 'application/vnd.ms-excel'
        const tableHTML = this.tableTarget.outerHTML.replace(/ /g, '%20')
        const downloadLink = document.createElement('a')
        downloadLink.href = 'data:' + dataType + ', ' + tableHTML
        downloadLink.download = 'export.xls'
        document.body.appendChild(downloadLink)
        downloadLink.click()
        document.body.removeChild(downloadLink)
    }
}
